export const LANGUAGES = {
  es: 'es-MX',
  en: 'en',
};
